import React from 'react'
import styles from './FetchLoading.module.css'
import { Spin, Empty } from 'antd'

const FetchLoading = ({ data, children }) => {
  return (
    <>
      {data === null ? (
        <div className={styles.container}>
          <Spin size="large" />
        </div>
      ) : data.length < 1 ? (
        <div className={styles.container}>
          <Empty />
        </div>
      ) : (
        children
      )}
    </>
  )
}

export default FetchLoading
